// extracted by mini-css-extract-plugin
export var container = "_d5-0";
export var infoIcon = "_d5-2";
export var internalLabel = "_d5-3";
export var titleRowCol = "_d5-1";